import { Injectable } from "@angular/core";

export enum DocumentOptionEnum {
    ALL_LINES = 'ALL_LINES',
    THIRDPART_LINE = 'THIRDPART_LINE',
  }

export type DocumentOptionType = {
    label: string;
    value: keyof typeof DocumentOptionEnum;
    tooltipLabel: string;
};

@Injectable()
export class DocumentService {

    private readonly documentList: DocumentOptionType[] = [
        {
            label: 'Rattacher le justificatif à toutes les lignes d\'écritures (import lent)',
            value: 'ALL_LINES',
            tooltipLabel: 'Les pièces justificatives seront associés à chaque lignes de l\'écriture. L\'import dans Quadratus sera plus lent mais le justificatif sera accessible depuis n\'importe quelle ligne de l\'écriture.'
        },
        {
            label: 'Rattacher le justificatif uniquement au compte de tiers',
            value: 'THIRDPART_LINE',
            tooltipLabel: 'Les pièces justificatives seront associés uniquement à la ligne du tiers (client, fournisseur, salarié…). L\'import dans Quadratus sera plus rapide mais le justificatif ne sera accessible que depuis une seule ligne de l\'écriture.'
        }
    ];

    public getAll(): DocumentOptionType[] {
        return [...this.documentList];
    }
}